import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { noop } from 'lodash/fp';
import * as styles from './Collapsible.css';

const cx = classnames.bind(styles);

export function Collapsible({
    collapsed = false,
    trigger = null,
    children,
    className,
    onToggle = noop
}) {
    const [isCollapsed, setIsCollapsed] = useState(collapsed);
    const collapseStyles = cx('collapsible', className, { isCollapsed });

    useEffect(() => {
        onToggle(isCollapsed);
    }, [onToggle, isCollapsed]);

    useEffect(() => {
        setIsCollapsed(collapsed);
    }, [collapsed]);

    function handleClick() {
        setIsCollapsed(!isCollapsed);
    }

    return (
        <div className={styles.base}>
            {trigger && (
                <div className={styles.trigger} onClick={handleClick}>
                    {trigger}
                </div>
            )}
            <div className={collapseStyles}>{!isCollapsed && children}</div>
        </div>
    );
}

Collapsible.propTypes = {
    children: PropTypes.node.isRequired,
    trigger: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    collapsed: PropTypes.bool,
    onToggle: PropTypes.func
};
